import { MarketTemplate } from "../../data";
import { prepareEmptyMarket } from "../../helpers/prepareEmptyMarket";
export const getAvailableOutrightMarket = (eventId, markets) => {
    return markets.length ? markets[0] : prepareEmptyMarket(eventId, MarketTemplate.ThreeBox, 0);
};
//# sourceMappingURL=getAvailableOutrightMarket.js.map